import { render, staticRenderFns } from "./ParametrosMainContainer.vue?vue&type=template&id=100300e2&scoped=true&"
import script from "./ParametrosMainContainer.vue?vue&type=script&lang=js&"
export * from "./ParametrosMainContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100300e2",
  null
  
)

export default component.exports